import AttachmentScheduleForm from '../Forms/AttachmentScheduleForm';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { actions } from '../../context';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

const AttachmentScheduleModal = () => {
    const dispatch = useDispatch();

    const practiceId = useSelector((state) => state.practice.practice.id);
    const practiceTimeZone = useSelector(
        (state) => state.practice.practice.timeZone
    );
    const [windowData, setWindowData] = useState(null);

    const isAttachmentScheduleModalOpen = useSelector(
        (state) => state.toggle.isAttachmentScheduleModalOpen
    );

    useEffect(() => {
        if (practiceId && isAttachmentScheduleModalOpen) {
            setWindowData(null);
            dispatch(
                actions.practice.getAttachmentSyncWindow(practiceId)
            ).then((res) => setWindowData(res || {}));
        }
    }, [dispatch, practiceId, isAttachmentScheduleModalOpen]);

    return (
        <Modal
            style={{ minWidth: '45vw' }}
            className="text-light"
            isOpen={isAttachmentScheduleModalOpen}
            centered={true}
            toggle={() =>
                dispatch(actions.toggle.toggleAttachmentScheduleModal())
            }>
            <ModalHeader>Attachment Extraction Scheduling</ModalHeader>
            <ModalBody>
                {windowData && (
                    <AttachmentScheduleForm
                        window={windowData}
                        practiceId={practiceId}
                        practiceTimeZone={practiceTimeZone}
                        cancel={() =>
                            dispatch(actions.toggle.toggleAttachmentScheduleModal())
                        }
                    />
                )}
            </ModalBody>
        </Modal>
    );
};

export default AttachmentScheduleModal;
